module.exports = __webpack_public_path__ + "img/评论.46b293bc.svg";